export default __webpack_public_path__ + "static/media/ttaCertifiedBadge.b2bc754f.svg";